import { h } from 'preact';
import { Trans } from '@lingui/macro';

const Menu = () => (
	<a href={'/nodeadmin'}><Trans>Node Configuration</Trans></a>
);

export default Menu;
